import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '../../utils/translation';
import { useLinkComponent } from '../../utils/component';

const P2p = styled.div`
  border-radius: 6px;
  border: solid 1px transparent;
  font-style: italic;
  line-height: 26px;
  margin: var(--spacer-fluid) 0 0;
  padding: var(--spacer-fluid);
`;

export const P2pInform = () => {
  const t = useTranslation();
  const LinkComponent = useLinkComponent();

  return (
    <P2p>
      <u>{t('design.inform.p2p.warning')}</u> :
      <br />
      <br />
      {t('design.inform.p2p.description')}&nbsp;
      <LinkComponent
        className="mod-primary"
        href="https://www.service-public.fr/particuliers/vosdroits/F32108"
        rel={['nofollow']}
        openInNewWindow
      >
        {t('design.inform.p2p.linkText')}
      </LinkComponent>
    </P2p>
  );
};
